import { useTranslation } from "react-i18next";
import { HelperText } from "react-native-paper";

type Props = {
	showError: boolean;
	errorMessage?: string;
};

const RedeemCodeErrorView = ({ showError, errorMessage }: Props) => {
	const { t } = useTranslation();

	if (showError) {
		return <HelperText type="error">{errorMessage}</HelperText>;
	}
	return <HelperText type="info">{t("redeemCode.accessCodeHint")}</HelperText>;
};

export default RedeemCodeErrorView;
